import React from 'react';
import './App.css';
import { CurrentUserContextProvider } from './Contexts/userContexts';
import { Routes, Route } from 'react-router-dom';
import PlayerList from './Components/PlayerList/PlayerList';
import Footer from './Components/Footer/Footer';
import NavBar from './Components/NavBar/NavBar';
import NavTeams from './Components/NavTeams/NavTeams'
import MyTeam from './Components/Pages/MyTeam';
import MyPlayers from './Components/Pages/MyPlayers';
import Carousel from './Components/Carousel/Carousel';




function App() {
  return (
    <CurrentUserContextProvider>
      <NavBar />
      <NavTeams />
      <Routes>
        <Route path="/" element={[<Carousel />, <Footer />]} />
        <Route path="/myTeam" element={<MyTeam />} />
        <Route path="/myPlayers" element={<MyPlayers />} />
        {/* <Route path="/league" element={<League />} /> */}
        <Route path="/players" element={<PlayerList />} />
      </Routes>
    </CurrentUserContextProvider>
  );
}

export default App;
























